import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // console.log('ScrollOffset module initialized');  
        // Select the element (e.g., the header) to get the CSS variable from
        const header = document.querySelector('header');

        if (header) {
            // Get the computed styles of the header
            const headerStyles = getComputedStyle(header);

            // Get the value of the CSS variable --header-height
            let headerHeight = headerStyles.getPropertyValue('--header-height').trim();

            // Convert the value to a number, make it negative, and add 40
            if (window.innerWidth <= 768) {
                headerHeight = (parseFloat(headerHeight) * -1) - 20; // Mobile value
            } else {
                headerHeight = (parseFloat(headerHeight) * -1) - 40; // Desktop value
            }
            

            // Log the value or use it as needed
            // console.log('Header height (negative + 40):', headerHeight);

            // Example usage: setting a property based on the header height
            this.headerHeight = headerHeight;

            // Update the data-scroll-default-offset attribute on load
            this.updateScrollOffset();

            // Add event listener for window resize to update the offset
            window.addEventListener('resize', this.updateScrollOffset.bind(this));
        } else {
            // console.error('Header element not found');
        }
    }

    updateScrollOffset() {
        const header = document.querySelector('header');
        if (header) {
            const headerStyles = getComputedStyle(header);
            let headerHeight = headerStyles.getPropertyValue('--header-height').trim();
            if (window.innerWidth <= 768) {
                headerHeight = (parseFloat(headerHeight) * -1) - 20; // Mobile value
            } else {
                headerHeight = (parseFloat(headerHeight) * -1) - 40; // Desktop value
            }
            const scrollElement = document.querySelector('[data-scroll-default-offset]');
            if (scrollElement) {
                scrollElement.setAttribute('data-scroll-default-offset', headerHeight);
                // console.log('Updated data-scroll-default-offset to:', headerHeight);
            } else {
                // console.error('Element with data-scroll-default-offset attribute not found');
            }
        }
    }


}
